// Silences the benign, DEV-ONLY "ResizeObserver loop …" notification that CRA's
// (react-error-overlay / webpack-dev-server) overlay escalates into a blocking modal.
// It is not a real error and never appears in production builds. This module is
// imported FIRST in index.js so the guards install before React, any library, or the
// dev-server client create a ResizeObserver or an error listener.

if (typeof window !== 'undefined') {
  const RO_MSG = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;

  // 1) Debounce every ResizeObserver callback into the next animation frame. This
  //    breaks the synchronous resize→layout→resize chain that emits the message, so in
  //    most cases it is never fired at all.
  if (typeof window.ResizeObserver === 'function') {
    const NativeResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class extends NativeResizeObserver {
      constructor(callback) {
        super((entries, observer) => {
          window.requestAnimationFrame(() => {
            if (typeof callback === 'function') callback(entries, observer);
          });
        });
      }
    };
  }

  // 2) Backstop: if the message still reaches the global error handler, swallow it and
  //    dismiss the dev overlay element. The dev-server client registers its own error
  //    listener before our app code, so stopImmediatePropagation can't reliably beat it
  //    — we hide the overlay node it renders instead (it uses a max z-index iframe).
  const dismissOverlay = () => {
    document
      .querySelectorAll('#webpack-dev-server-client-overlay, #webpack-dev-server-client-overlay-div, iframe[style*="2147483647"]')
      .forEach((el) => { el.style.display = 'none'; });
  };
  window.addEventListener('error', (e) => {
    if (e && RO_MSG.test(e.message || '')) {
      e.stopImmediatePropagation();
      e.preventDefault();
      dismissOverlay();
      window.requestAnimationFrame(dismissOverlay); // overlay may mount just after the error
    }
  }, true);
}
